import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import { HelmetProvider } from 'react-helmet-async';

import App from './App';
import './css/style.css';
import './css/responsive.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

ReactDOM.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
  document.getElementById('root'),
  function() {
    $('#preloader').delay(0).fadeOut();
  }
);
